import { useContext } from "react";

import { ChildRoutesContext } from "../contexts/ChildRoutesContext";

export function useChildRoutes() {
  const context = useContext(ChildRoutesContext);

  return context;
}
